import { MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";

class TableColumnInfo {
    public ColumnName: string;
    public ColumnText: string;
    public IsHidden: boolean;

    constructor(option?: ColumnConfigurationModel) {
        if (option != null) {
            this.ColumnName = option.ColumnUniqueName;
            this.ColumnText = option.ColumnText;
            this.IsHidden = option.IsHidden;
        }
    }
}

class ColumnConfigurationModel {
    public ColumnUniqueName: string;
    public ColumnText: string;
    public IsHidden: boolean;
    public IsSelected: boolean;
    public IsFixedInPlace: boolean;
    public DefaultWidthRatio: number;

    constructor(options?: MyleTableColumnOptions) {
        if (options != null) {
            this.ColumnUniqueName = options.FieldName;
            this.ColumnText = options.HeaderText;
            this.IsHidden = options.IsHidden;
            this.IsSelected = false;
            this.IsFixedInPlace = options.IsFixedInPlace;
            this.DefaultWidthRatio = options.WidthPercentageDefault;
        }
    }
}

export { ColumnConfigurationModel, TableColumnInfo };
